
import * as React from 'react';
import { PropsWithChildren } from 'react';

type SecuredElement = PropsWithChildren<{
  unauthenticatedElement: JSX.Element;
  unauthorizedElement: JSX.Element;
  isAuthenticated: boolean;
  isAuthorized: boolean;
}>

const securedElement: React.FC<SecuredElement> = (props) => {
  
  if (!props.isAuthenticated) {
    return props.unauthenticatedElement;
  }
  if (!props.isAuthorized) {
    return props.unauthorizedElement;
  }
  return <>{props.children}</>;
};

export default securedElement;